import { render, staticRenderFns } from "./ganttEditView.vue?vue&type=template&id=2fc211b0&"
import script from "./ganttEditView.vue?vue&type=script&lang=js&"
export * from "./ganttEditView.vue?vue&type=script&lang=js&"
import style0 from "./ganttEditView.vue?vue&type=style&index=0&id=2fc211b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports